import {
  AIRCRAFT_LIST_RECEIVED,
  ASSET_LIST_RECEIVED,
  ASSET_PARTS_LIST_RECEIVED,
  AIRCRAFT_PARTS_RECEIVED,
  AIRCRAFT_TYPE_LIST,
  ASSEMBLIES_LIST_RECEIVED,
  AIRCRAFT_ID_PARTS_RECEIVED,
  AIRCRAFT_CREATED_RECEIVED,
  TYPE_CREATED,
  ASSET_CREATED,
  ASSET_VERSION_CREATED,
  ASSET_VERSIONS_RECEIVED,
  ASSET_VERSION_DELTA_RECEIVED,
  ASSET_VERSION_RECEIVED,
  ASSET_VERSION_DELTA_APPLIED,
  ASSET_PART_REPLACED,
  ASSET_PART_DEACTIVATED,
  INACTIVE_ASSET_PARTS_LIST_RECEIVED,
  ASSET_VERSION_ASSEMBLIES_RECEIVED
} from 'actions/actionTypes';

const defaultState = {
  aircraft: [],
  parts: { list: [], byId: {} },
  assetVerions: [],
  assemblies: { list: [], byId: {} },
  newAircraft: null,
  types: []
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case ASSET_VERSION_ASSEMBLIES_RECEIVED: {
      return { ...state, versionAssemblies: action.payload };
    }
    case INACTIVE_ASSET_PARTS_LIST_RECEIVED: {
      return { ...state, inactiveAssetParts: action.payload };
    }
    case ASSET_PART_DEACTIVATED: {
      return { ...state, assetPartDeactivated: action.payload };
    }
    case ASSET_PART_REPLACED: {
      return { ...state, assetPartReplaced: action.payload };
    }
    case ASSET_VERSION_DELTA_APPLIED: {
      return { ...state, assetVersionDeltaApplied: action.payload };
    }
    case ASSET_VERSIONS_RECEIVED: {
      return { ...state, assetVersions: action.payload };
    }
    case ASSET_VERSION_RECEIVED: {
      return { ...state, assetVersion: action.payload };
    }
    case ASSET_VERSION_DELTA_RECEIVED: {
      return { ...state, assetVersionDelta: action.payload };
    }
    case ASSET_VERSION_CREATED: {
      return { ...state, assetVersion: action.payload };
    }
    case ASSET_CREATED: {
      return { ...state, asset: action.payload };
    }
    case ASSET_LIST_RECEIVED: {
      return { ...state, assets: action.payload };
    }
    case ASSET_PARTS_LIST_RECEIVED: {
      return { ...state, assetParts: action.payload };
    }
    case AIRCRAFT_LIST_RECEIVED: {
      return { ...state, aircraft: action.payload };
    }
    case AIRCRAFT_PARTS_RECEIVED: {
      return { ...state, parts: { ...state.parts, list: action.payload } };
    }
    case AIRCRAFT_ID_PARTS_RECEIVED: {
      return {
        ...state,
        parts: {
          ...state.parts,
          byId: {
            ...state.parts.byId,
            [action.payload.id]: action.payload.parts
          }
        }
      };
    }
    case AIRCRAFT_TYPE_LIST: {
      return { ...state, types: action.payload };
    }
    case ASSEMBLIES_LIST_RECEIVED: {
      return {
        ...state,
        assemblies: {
          ...state.assemblies,
          [action.payload.type]: action.payload.assemblies
        }
      };
    }
    case AIRCRAFT_CREATED_RECEIVED: {
      return { ...state, newAircraft: action.payload };
    }
    case TYPE_CREATED: {
      return state;
    }
    default:
      return state;
  }
};
